// Оперативные события терминала.
//
// Приёмка идёт с телефона: оператор сканирует VIN и ставит машину в ячейку, а
// диспетчер на ПК до сих пор узнавал об этом только по F5 — на части страниц
// из-за этого выросли кнопки «Обновить». Канал TerminalChannel сообщает о
// приёмке, размещении, перемещении, растарке и приёмке груза; страница
// подписывается на нужные ей типы событий.
//
// Использование:
//   import terminalChannel from '@/mixins/terminalChannel'
//   export default {
//     mixins: [terminalChannel],
//     mounted () {
//       this.watchTerminal(['vehicle'], () => this.initialize(true))
//     }
//   }

import cableChannel from './cableChannel'

// Растарка контейнера — это серия сканов подряд: восемь машин из КТК дают
// восемь событий за несколько секунд. Без склейки список перезагружался бы
// восемь раз, показывая оператору мигающую таблицу вместо данных.
const DEFAULT_DELAY = 400

export default {
  mixins: [cableChannel],

  methods: {
    // watchTerminal(['vehicle', 'container_ticket'], handler, { delay, actions })
    watchTerminal (models, handler, options = {}) {
      const actions = options.actions || null

      this._terminalHandler = handler
      this._terminalDelay = options.delay != null ? options.delay : DEFAULT_DELAY

      this.subscribeChannel({
        channel: 'TerminalChannel',
        handlers: {
          received: (data) => {
            if (!data || !models.includes(data.model)) return
            if (actions && !actions.includes(data.action)) return

            // Вкладку с открытым списком нередко держат фоном всю смену.
            // Перезагружать её в фоне незачем: событие запоминаем и применяем,
            // когда на вкладку вернутся, — иначе смена даёт сотни запросов
            // за данными, которых никто не видит.
            // Последнее событие передаём обработчику: страницам списков оно
            // не нужно, а шапке — нужно, чтобы показать, о чём пришло
            // сообщение, не перезапрашивая его заново.
            this._terminalLastEvent = data

            if (document.hidden) {
              this._terminalPending = true
              return
            }

            this.scheduleTerminalReload()
          }
        }
      })

      this._terminalVisibility = () => {
        if (document.hidden || !this._terminalPending) return

        this._terminalPending = false
        this.scheduleTerminalReload()
      }
      document.addEventListener('visibilitychange', this._terminalVisibility)
    },

    scheduleTerminalReload () {
      clearTimeout(this._terminalTimer)
      this._terminalTimer = setTimeout(() => {
        if (this._terminalHandler) this._terminalHandler(this._terminalLastEvent)
      }, this._terminalDelay != null ? this._terminalDelay : DEFAULT_DELAY)
    }
  },

  beforeDestroy () {
    clearTimeout(this._terminalTimer)

    if (this._terminalVisibility) {
      document.removeEventListener('visibilitychange', this._terminalVisibility)
      this._terminalVisibility = null
    }
  }
}
